import {v4 as uuidv4} from "uuid";
import {none, Option, option} from "ts-option";
import {FormField, OptionalFormField, RequiredFormField} from "../../../../validation/FormField";
import JobType from "../../../../model/job/JobType";
import BaseFormController from "../../../../validation/BaseFormController";
import FormValidators from "../../../../validation/FormValidators";
import FormValidation from "../../../../validation/FormValidation";

export default class JobTypeForm extends BaseFormController<JobTypeForm> {

	public static createJobTypeForm(jobType: JobType) {
		const label = option(jobType.name);
		const activityTemplateId = jobType.activityTemplateId;
		const labourOnly = option(jobType.labourOnly);
		const fee = option(jobType.fee);
		const repairWithParts = option(jobType.repairWithParts);
		const active = option(jobType.active);

		const labelField = RequiredFormField.create<string>(label, "Label is required", [
			FormValidators.nonEmptyString("Label is required")
		]);
		return new JobTypeForm(
			uuidv4(),
			labelField,
			OptionalFormField.create<string>(activityTemplateId),
			RequiredFormField.create<boolean>(labourOnly, "Labour only field is required"),
			RequiredFormField.create<number>(fee, "Fee field is required"),
			RequiredFormField.create<boolean>(active, "Active field is required"),
			RequiredFormField.create<boolean>(repairWithParts, "Repairs with parts field is required"),
			labelField
		);
	}

	constructor(public readonly formId: string,
		public readonly label: RequiredFormField<string>,
		public readonly activityTemplateId: OptionalFormField<string>,
		public readonly labourOnly: RequiredFormField<boolean>,
		public readonly fee: RequiredFormField<number>,
		public readonly active: RequiredFormField<boolean>,
		public readonly repairWithParts: RequiredFormField<boolean>,
		public readonly fieldWithFocus: FormField<string>) {
		super(fieldWithFocus, formId);
	}

	onValid(callback: (data: JobType) => void) {
		const result = FormValidation.validateFields(
			[this.label, this.activityTemplateId, this.labourOnly, this.active, this.fee],
			() => {
				return new JobType(
					uuidv4(),
					this.label.getValue(),
					this.activityTemplateId.getOptionalValue(),
					this.labourOnly.getValue(),
					this.fee.getValue(),
					this.repairWithParts.getValue(),
					this.active.getValue()
				)
			}
		);
		result.onSuccess((data) => {
			callback(data);
		});
	}

	copy({
		label = this.label,
		activityTemplateId = this.activityTemplateId,
		labourOnly = this.labourOnly,
		fee = this.fee,
		repairWithParts = this.repairWithParts,
		active = this.active
	}): JobTypeForm {
		return new JobTypeForm(this.formId,
			label,
			activityTemplateId,
			labourOnly,
			fee,
			active,
			repairWithParts,
			this.fieldWithFocus);
	}

	fields(): Array<FormField<any>> {
		return [this.label, this.activityTemplateId, this.labourOnly, this.active];
	}
}
